// extracted by mini-css-extract-plugin
export var badge = "_ut-4";
export var selected = "_ut-1";
export var selectedOverlay = "_ut-5";
export var thumbnailButton = "_ut-0";
export var thumbnailFallback = "_ut-3";
export var thumbnailImage = "_ut-2";